import { render, staticRenderFns } from "./get_Instant_quote.vue?vue&type=template&id=5bc21a4d&scoped=true"
import script from "./get_Instant_quote.vue?vue&type=script&setup=true&lang=js"
export * from "./get_Instant_quote.vue?vue&type=script&setup=true&lang=js"
import style0 from "./get_Instant_quote.vue?vue&type=style&index=0&id=5bc21a4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc21a4d",
  null
  
)

export default component.exports